import styledCmp from 'styled-components'
import ReactLoading from 'react-loading'

import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';

export const Load = styledCmp(ReactLoading).attrs(props => ({
    type: 'spin',
    color: props.theme.palette[props.theme.palette[props?.color] ? props?.color : "primary"]?.[props.outline ? "main" : "contrastText"],
    height: 20,
    width: 20
}))`
`;

export const ColorButton = styled(Button)(({ theme, nospace, width, small, color }) => ({
    width: width ? width : '100%',
    height: small ? '40px' : '45px',
    marginTop: nospace ? '0px' : '12px',
    textTransform: 'none',
    fontFamily: 'Poppins',
    fontSize: '16px',
    boxShadow: 'none',
    '&.MuiButton-contained': {
        boxShadow: 'none',
    },
    '&.MuiButton-contained:hover': {
        boxShadow: 'none',
    },
    '&.Mui-disabled': {
        backgroundColor: color === 'blue'
            ? theme.palette.colors.disabledBackground
            : theme.palette.action.disabledBackground,
        color: color === 'blue'
            ? theme.palette.colors.disabledText
            : theme.palette.action.disabled,
        opacity: 1,
    },
}));
